import { DecisionNext } from './types';

/**
 * Type guard function to check if a value is a DecisionNext object.
 * @param obj The object to check.
 * @returns true if the object is a DecisionNext, otherwise false.
 */
export const isDecisionNext = (obj: any): obj is DecisionNext =>
  obj !== null &&
  typeof obj === 'object' &&
  typeof obj.nextNodeId === 'string' &&
  (obj.result === 'true' || obj.result === 'false');

/**
 * Checks if a given value is an array of DecisionNext objects.
 * This function uses a type guard to ensure type safety.
 * @param value The value to check.
 * @returns true if the value is an array of DecisionNext objects, otherwise false.
 */
export function isDecisionNextArray(
  value: unknown,
): value is Array<DecisionNext> {
  if (!Array.isArray(value)) {
    return false;
  }
  return value.every(isDecisionNext);
}

/**
 * Checks if a given value is an array of strings
 * as this is the expected format for action next nodes.
 */
export function isActionNextArray(value: unknown): value is Array<string> {
  if (!Array.isArray(value)) {
    return false;
  }
  return value.every((x) => typeof x === 'string');
}
